import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import Table from "@amzn/meridian/table";
import TableRow from "@amzn/meridian/table/table-row";
import TableCell from "@amzn/meridian/table/table-cell";
import {chainWalk, formQueryParams} from "../../Utility";
import {FormattedMessage} from "react-intl";
import {getStowCartDataForFloor} from "../../actions/FloorActions";
import CartStatus from "./CartStatus";
import Link from "@amzn/meridian/link";
import Loading from "../utils/Loading";
import BinTableCell from "./BinTableCell";
import OvCartTableCell from "./OvCartTableCell";
import OVBinTableCell from "./OVBinTableCell";
import ErrorPage from "../utils/ErrorPage";
import {PackageStatus, CartType} from "../../enums";
import {FLOOR_LOCATION, GROUP_BY, STATION_PAIR} from "../../constants";

class Floor extends Component {

    constructor(props) {
        super(props);
        this.state = {
            expandedFloors: []
        }
    }

    render() {

        const error = this.props.error

        if (error) {
            return <ErrorPage errorId="stow.error" errorMessage="Some error occurred"/>
        }

        const floors = this.getDistinctFloors().sort()

        if (this.props.loading && !floors.length) {
            return <Loading/>
        }

        return (
            <Table headerRows={1} showDividers={false} showStripes={false} spacing="small" fixHeaderRows={true}
                   fixHeaderRowsFullWidth={true}>
                {this.renderHeadings()}
                {floors.map((floor) => (this.renderFloorRow(floor)))}
            </Table>
        )
    }

    getDistinctFloors = () => {
        const allFloors = [
            ...Object.keys(this.props.inductPackageMetricsMap),
            ...Object.keys(this.props.pickPackageMetricsMap),
            ...Object.keys(this.props.stowFloorsData),
            ...Object.keys(this.props.stowPackageMetricsMap)
        ];

        return [...new Set(allFloors)];
    }

    renderHeadings = () => {
        return (
            <TableRow>
                <TableCell>
                    <FormattedMessage id="floor.location" defaultMessage="Location"/>
                </TableCell>
                <TableCell>
                    <FormattedMessage id="floor.route" defaultMessage="Route"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="floor.inducted" defaultMessage="Inducted"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="floor.picked" defaultMessage="Picked"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="floor.stowed" defaultMessage="Stowed"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="floor.problem_solve" defaultMessage="PS"/>
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    <FormattedMessage id="floor.stow_readiness" defaultMessage="Stow Readiness"/>
                </TableCell>
                <TableCell>
                    <FormattedMessage id="floor.cart_status" defaultMessage="Cart status"/>
                </TableCell>
            </TableRow>
        );
    }

    renderFloorRow = (floor) => {
        const combinedMetricsMap = this.getCombinedMetricsMap(floor)

        return (
            <TableRow highlightOnHover={true} key={floor} open={this.isFloorExpanded(floor)}
                      onClick={() => this.floorRowClicked(floor)}>
                <TableCell>{this.getDisplayLabel(floor)}</TableCell>
                <TableCell>
                    {combinedMetricsMap.routeCode}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.inductedPackages, floor, PackageStatus.CURRENT_INDUCTED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.pickedPackages, floor, PackageStatus.PICKED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.stowedPackages, floor, PackageStatus.STOWED)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {this.renderPackageCount(combinedMetricsMap.problemSolvePackages, floor, PackageStatus.PROBLEM_SOLVE)}
                </TableCell>
                <TableCell alignmentHorizontal="right">
                    {combinedMetricsMap.cartReadiness}
                </TableCell>
                <TableCell>
                    <CartStatus status={combinedMetricsMap.cartStatus}/>
                </TableCell>
                {this.renderCart(floor)}
            </TableRow>
        );
    }

    getCombinedMetricsMap = floor => {
        const {
            inductPackageMetricsMap,
            pickPackageMetricsMap,
            stowFloorsData,
            stowPackageMetricsMap
        } = this.props;
        const defaultMetricValue = "-"

        const cartType = chainWalk(() => stowFloorsData[floor].cart.type, null)
        const cartReadiness = cartType === "OV" ? "OV" : chainWalk(() => stowFloorsData[floor].cart.readiness, defaultMetricValue) + "%"

        return {
            routeCode: chainWalk(() => stowFloorsData[floor].routeCode, defaultMetricValue),
            inductedPackages: chainWalk(() => inductPackageMetricsMap[floor].inductedPackages, defaultMetricValue),
            pickedPackages: chainWalk(() => pickPackageMetricsMap[floor].pickedPackages, defaultMetricValue),
            stowedPackages: chainWalk(() => stowPackageMetricsMap[floor].stowedPackages, defaultMetricValue),
            problemSolvePackages: chainWalk(() => stowPackageMetricsMap[floor].problemSolvePackages, defaultMetricValue),
            cartReadiness: cartReadiness,
            cartStatus: chainWalk(() => stowFloorsData[floor].cart.status, "MISSING")
        }
    }

    getDisplayLabel = (floor) => {
        return chainWalk(() => floor.split(".")[1], floor)
    }

    isFloorExpanded = (floor) => {
        return (this.state.expandedFloors.indexOf(floor) !== -1);
    }

    renderCart = (floor) => {
        const cart = this.getCart(floor)
        if (cart) {
            switch (cart.type) {
                case CartType.OV:
                    return this.renderOvCart(cart);
                case CartType.HYBRID:
                    return this.renderHybridCart(cart);
                case CartType.NORMAL:
                    return this.renderNormalCartBins(cart);
                default:
                    return this.renderNormalCartBins(cart);
            }
        }
        return <TableRow/>
    }

    getCart = (floor) => {
        const cartData = this.props.stowCartData;
        if (cartData && cartData[floor]) {
            return cartData[floor]
        }
    }

    renderOvCart = (cart) => {
        return (
            <TableRow>
                <OvCartTableCell cart={cart}/>
            </TableRow>
        )
    }

    renderOvPackages = (cart) => {
        return (
            <TableRow>
                <OVBinTableCell cart={cart}/>
            </TableRow>
        )
    }

    renderHybridCart = (cart) => {
        const bins = cart.bins
        if (bins) {
            const binArray = bins.map(bin => this.renderBin(bin));
            binArray.push(this.renderOvPackages(cart));
            return binArray;
        }
    }

    renderNormalCartBins = (cart) => {
        const bins = cart.bins
        if (bins) {
            return bins.map(bin => this.renderBin(bin))
        }
    }

    renderBin = (bin) => {
        return (
            <TableRow>
                <BinTableCell bin={bin}/>
            </TableRow>
        )
    }

    renderPackageCount = (value, floor, state) => {
        return value !== 0 && value !== '-' ?
            <Link href={this.getPackageListURL(state, floor)}
                  type="secondary"> {value} </Link> : value
    }

    getPackageListURL = (state, floor) => {
        const params = {
            PACKAGE_STATUS: state,
            FLOOR: floor
        }
        if (PackageStatus.PICKED === state) {
            params[GROUP_BY] =  FLOOR_LOCATION;
            params[STATION_PAIR] =  floor.split(".")[0];
        }
        return "#packageList/?" + formQueryParams(params);
    }

    floorRowClicked = floor => {
        this.setState((oldState) => {
            if (oldState.expandedFloors.indexOf(floor) !== -1) {
                return {
                    expandedFloors: oldState.expandedFloors.filter(expandedFloor => expandedFloor !== floor)
                }
            } else {
                this.props.dispatch(getStowCartDataForFloor(this.props.nodeId, floor));
                return {
                    expandedFloors: oldState.expandedFloors.concat(floor)
                }
            }
        })
    }
}

const mapStateToProps = state => ({
    loading: state.floorReducer.loading,
    error: state.floorReducer.error,
    inductPackageMetricsMap: state.floorReducer.inductPackageMetricsMap,
    pickPackageMetricsMap: state.floorReducer.pickPackageMetricsMap,
    stowCartData: state.floorReducer.stowCartData,
    stowFloorsData: state.floorReducer.stowFloorsData,
    stowPackageMetricsMap: state.floorReducer.stowPackageMetricsMap,
});
export default withRouter(connect(mapStateToProps)(Floor));



// WEBPACK FOOTER //
// ./src/components/floor/Floor.js